import {
  usePersistedSessionState,
  useUrlParameterFromRegex,
  useShoppingType,
  useRouter,
} from '@edreamsodigeo/frontend-core';
import { useMemo } from 'react';

const BOOKING_ID_REGEX = new RegExp(/.*\/(\d{10,12})\/.*$/);
const SHOPPING_ID_REGEX = new RegExp(
  /.*\/([0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12})\/.*$/
);

export const useShoppingBundleInfo = () => {
  const { query } = useRouter();

  const [, bookingId] = useUrlParameterFromRegex(BOOKING_ID_REGEX);
  const [, shoppingIdUrl] = useUrlParameterFromRegex(SHOPPING_ID_REGEX, [
    '',
    '',
  ]);

  const shoppingType = useShoppingType();
  const [bookingIdFromSession] = usePersistedSessionState('bookingId');

  const shoppingId =
    query?.bookingId ||
    query?.shoppingId ||
    bookingId ||
    shoppingIdUrl ||
    bookingIdFromSession ||
    0;

  return useMemo(
    () => ({
      shoppingId: `${shoppingId}`,
      shoppingType: shoppingType || 'CART',
    }),
    [shoppingId, shoppingType]
  );
};
